export const FEATURES = {
  BESOIN_DAIDE: 'besoindaide',
  UNIVERSE_AMC: 'universeAMC',
  UNIVERSE_ASI: 'universeASI',
  ACAPS: 'acaps',
  NO_ACAPS: 'noAcaps',
};
